import { ReactElement, useCallback, useEffect, useState } from 'react';

import { AxiosResultDefaultError } from '../../../api/request';
import DisplayError from '../../../components/info/DisplayError';
import Loading from '../../../components/info/Loading';
import { useLoadingState } from '../../../hooks/useLoadingState';
import { StudentsPetitionsDetail } from '../Received/types/petitionDetail';
import {
  getPetitionStatusPdf,
  getStudentPetitionDetail,
} from '../services/requests';

export interface BaseLoaderProps {
  petitionId: number | string;
  children: (props: StudentsPetitionsDetail) => ReactElement;
}

export default function BaseLoader({ petitionId, children }: BaseLoaderProps) {
  const { loading, setLoading } = useLoadingState();

  const [data, setData] = useState<StudentsPetitionsDetail>();
  const [error, setError] = useState<AxiosResultDefaultError>();

  const load = useCallback(async () => {
    setLoading(true);

    const response = await getStudentPetitionDetail(petitionId);

    if (response?.data?.linkedFiles && response.data.linkedFiles.length > 0) {
      const pdfFiles = await Promise.all(
        response.data.linkedFiles.map(async (file: any) => {
          const responseFile = await getPetitionStatusPdf(file.id);
          return responseFile.data;
        }),
      );
      response.data.pdfFiles = pdfFiles;
    }

    if (response?.data?.linkedFileResponse) {
      const responseFile = await getPetitionStatusPdf(
        response.data.linkedFileResponse.id,
      );
      response.data.fileResponse = responseFile.data;
    }

    if (response.data) {
      setData(response.data);
      setError(undefined);
    }
    if (response.error) {
      setError(response.error);
    }
    setLoading(false);
  }, [setLoading, petitionId]);

  useEffect(() => {
    load();
  }, [load]);

  if (error) {
    return (
      <DisplayError
        insideCard
        textBody={error.code}
        retryAction={load}
        loadingAction={loading}
      />
    );
  }

  if (loading) {
    return <Loading insideCard />;
  }

  if (!data) {
    return (
      <DisplayError
        insideCard
        textBody="Data no cargada"
        retryAction={load}
        loadingAction={loading}
      />
    );
  }

  return children(data);
}
